import { render, staticRenderFns } from "./ResetPurchase.vue?vue&type=template&id=3f021af8&"
import script from "./ResetPurchase.vue?vue&type=script&lang=js&"
export * from "./ResetPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports